import _taggedTemplateLiteral from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  query($order: [MembersFindOrder!],$where: MembersFindFilter) {\n    exportMembersList(\n      order: $order,\n      where: $where\n    ) {\n      fileName\n      contentB64\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  mutation($memberId: Int!) {\n    deleteMember(memberId: $memberId)\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query($order: [MembersFindOrder!], $paging: PagingQuery, $where: MembersFindFilter) {\n    findMembers(\n      order: $order,\n      paging: $paging,\n      where: $where,\n    ) {\n      members {\n        id\n        nickname\n        profilePhoto\n        uniqueId\n        createdAt\n        updatedAt\n      }\n      paging {\n        currentOffset\n        take\n        totalCount\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from 'graphql-tag';
export var findMembers = gql(_templateObject());
export var deleteMember = gql(_templateObject2());
export var exportMembersList = gql(_templateObject3());